import React, { useCallback, useEffect, useState } from 'react';
import api from '../services/api';
import usePullToRefresh from '../hooks/usePullToRefresh';

const AdminPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(() => {
    setLoading(true);
    api
      .get('/api/admin/dashboard')
      .then(({ data }) => setData(data))
      .catch(() => setData({ error: 'Forbidden' }))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  usePullToRefresh(fetchData);

  return (
    <div>
      <h1>Admin</h1>
      {loading ? (
        <div className="table-skeleton">
          <div className="skeleton skeleton-line skeleton-line--wide" />
          <div className="skeleton skeleton-line" />
          <div className="skeleton skeleton-line" />
          <div className="skeleton skeleton-line skeleton-line--wide" />
          <div className="skeleton skeleton-line" />
        </div>
      ) : (
        <pre>{JSON.stringify(data, null, 2)}</pre>
      )}
    </div>
  );
};

export default AdminPage;
